// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"144f3efa","732":"f1f351de","977":"fbb63b50"}[chunkId] + ".chunk.js";
};